module.exports = __webpack_public_path__ + "static/media/electronic-commerce.1908a648.png";